import React from "react";

export default function EmojiResultScreen({ game }) {
  const {
    score,
    bestCombo,
    accuracy,
    elapsed,
    gridCapacity,
    correct,
    wrong,
    settings,
    grid,           // collected count
  } = game;

  const total = correct + wrong;
  const xp = score + (accuracy * 10) + (bestCombo * 25);
  const isBest = false; // You can enhance this later using bestScore comparison

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white overflow-y-auto pb-10">
      {/* HEADER */}
      <div className="sticky top-0 z-30 bg-slate-950/90 backdrop-blur border-b border-yellow-500/20">
        <div className="flex items-center justify-center py-4">
          <div className="text-center">
            <div className="text-5xl">🎉</div>
            <div className="mt-2 text-2xl font-black text-yellow-300">
              GAME COMPLETED
            </div>
            <div className="text-sm text-slate-400 mt-1">
              {settings.category} • {settings.gridSize}×{settings.gridSize} Grid
            </div>
          </div>
        </div>
      </div>

      {/* MAIN SCORE */}
      <div className="px-4 mt-6">
        <div className="rounded-3xl bg-gradient-to-r from-yellow-400 via-orange-400 to-pink-500 p-[1px]">
          <div className="rounded-3xl bg-slate-900 p-6 text-center">
            <div className="text-6xl">🏆</div>
            <div className="mt-3 text-6xl font-black text-yellow-300">
              {score}
            </div>
            <div className="text-sm text-slate-400 mt-1">FINAL SCORE</div>
          </div>
        </div>
      </div>

      {/* STATS GRID */}
      <div className="px-4 mt-6">
        <div className="grid grid-cols-2 gap-3">
          <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4 text-center">
            <div className="text-xs text-slate-500">XP Earned</div>
            <div className="mt-1 text-3xl font-black text-green-400">⭐ {xp}</div>
          </div>

          <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4 text-center">
            <div className="text-xs text-slate-500">Accuracy</div>
            <div className="mt-1 text-3xl font-black text-cyan-400">🎯 {accuracy}%</div>
          </div>

          <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4 text-center">
            <div className="text-xs text-slate-500">Best Combo</div>
            <div className="mt-1 text-3xl font-black text-pink-400">🔥 x{bestCombo}</div>
          </div>

          <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4 text-center">
            <div className="text-xs text-slate-500">Collected</div>
            <div className="mt-1 text-3xl font-black text-emerald-400">
              {grid.length} / {gridCapacity}
            </div>
          </div>
        </div>
      </div>

      {/* TIME & PERFORMANCE */}
      <div className="px-4 mt-6">
        <div className="rounded-2xl bg-slate-900 border border-violet-500/30 p-5">
          <div className="flex justify-between items-center">
            <div className="font-black text-violet-300">Time Taken</div>
            <div className="text-2xl font-bold text-orange-300">
              ⏱ {(elapsed / 1000).toFixed(1)}s
            </div>
          </div>

          <div className="mt-5 h-3 bg-slate-800 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-green-400 to-cyan-400"
              style={{ width: `${accuracy}%` }}
            />
          </div>
        </div>
      </div>

      {/* ENCOURAGEMENT */}
      <div className="px-4 mt-8">
        <div className="rounded-3xl bg-gradient-to-br from-green-500/10 to-cyan-500/10 border border-cyan-500/20 p-6 text-center">
          <div className="text-4xl">🥳</div>
          <div className="mt-3 text-xl font-black text-cyan-300">
            Excellent Job!
          </div>
          <div className="text-sm text-slate-400 mt-2">
            Keep practicing daily to improve focus and reaction speed.
          </div>
        </div>
      </div>

      {/* ACTION BUTTONS */}
      <div className="px-4 mt-8 space-y-3">
        <button
          onClick={game.restartGame}
          className="w-full py-4 rounded-2xl bg-cyan-500 text-black font-black text-lg active:scale-95 transition"
        >
          🔄 Play Again
        </button>

        <button
          onClick={() => game.setScreen("leaderboard")}
          className="w-full py-4 rounded-2xl bg-violet-600 font-black text-lg active:scale-95 transition"
        >
          🏆 View Leaderboard
        </button>

        <button
          onClick={() => game.setScreen("history")}
          className="w-full py-4 rounded-2xl bg-slate-800 border border-slate-700 font-black text-lg active:scale-95 transition"
        >
          📜 Score History
        </button>

        <button
          onClick={() => game.setScreen("home")}
          className="w-full py-4 rounded-2xl border border-cyan-500 text-cyan-300 font-black text-lg active:scale-95 transition"
        >
          🏠 Back to Home
        </button>
      </div>
    </div>
  );
}